// Единая точка входа: доменные экраны берут ресурсы бэкенда отсюда, а не
// подключаются к файлам-модулям напрямую — так виднее, что вообще есть.
import { login } from './auth'
import { accounts } from './accounts'
import { items, item, createItem, uploadPhoto } from './items'
import { listings, schedule, cancel, runNow } from './listings'

export { login }

export const api = {
  accounts,
  items,
  item,
  createItem,
  uploadPhoto,
  listings,
  schedule,
  cancel,
  runNow,
}
